import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "./layout"
import Img from "gatsby-image"


export default function BlogPost({ data }) {
  const post = data.markdownRemark
  let featuredImgFluid = post.frontmatter.featuredImage.childImageSharp.fluid

  return (
    <Layout>

        <div className="post">
        <Link to="/blog/" className='link'>←</Link>
      <h1 className="postTitle">{post.frontmatter.title}</h1>
      <Img fluid={featuredImgFluid} />
      <small>{post.frontmatter.date}</small>
      <div dangerouslySetInnerHTML={{ __html: post.html }} />

      <Link to="/blog/" className='link'>←</Link>
    </div>
   <br/>

    </Layout>

  )
}

export const query = graphql`
  query BlogQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        featuredImage {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
